import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import EmergencyResponseCenter from "./sections/EmergencyResponseCenter";
import CitizenActionPortal from "./sections/CitizenActionPortal";
import CommunityWatchAlerts from "./sections/CommunityWatchAlerts";
import DepartmentalTransparency from "./sections/DepartmentalTransparency";
import JoinOurRanks from "./sections/JoinOurRanks";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <EmergencyResponseCenter />
      <CitizenActionPortal />
      <CommunityWatchAlerts />
      <DepartmentalTransparency />
      <JoinOurRanks />
      <Footer />
    </div>;
}